export default [
  {
    title: 'main_menu.dashboard',
    customIcon: 'AnalyticIcon',
    path: '/analytics/dashboard',
    children: [],
  },
];
